import React from "react";

const RowContext = React.createContext({});

export { RowContext };
